'use strict';

function actorDisplayName(name) {
  const raw = String(name || '').trim();
  if (!raw || /^(unknown|system)$/i.test(raw)) return 'Soren';
  return raw;
}

function actorInitials(name) {
  const raw = String(name || '').trim();
  if (!raw || /^(soren|system|unknown)$/i.test(raw)) return 'S';
  const parts = raw.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
  }
  const letters = parts[0].replace(/[^A-Za-z]/g, '');
  return (letters[0] || 'S').toUpperCase();
}

export { actorDisplayName, actorInitials };
